import { DocumentLibraryAdd } from '#app/routes/mocra+/_form+/components/document-libraries/add.tsx'
import { DocumentLibraryCard } from '#app/routes/mocra+/_form+/components/document-libraries/card.tsx'
import { type DocumentLibraryDraft } from '#app/routes/mocra+/_form+/components/document-libraries/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type DocumentLibraryListItem = {
	readonly draft: DocumentLibraryDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly libraries: ReadonlyArray<DocumentLibraryListItem>
	readonly onAdd: (draft: DocumentLibraryDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
}

export function DocumentLibrariesSection({
	resources,
	libraries,
	onAdd,
	onEdit,
	onRemove,
}: Props) {
	return (
		<Section
			title="Document libraries"
			description="Map the repositories where controlled procedures, forms, and training records live."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{libraries.length > 0 ? (
					libraries.map((library, index) => {
						const errors = library.errors
						return (
							<DocumentLibraryCard
								key={`document-library-${index}`}
								library={library.draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">
						Add your first document library to show where controlled SOPs live.
					</p>
				)}
			</div>
			<DocumentLibraryAdd onSubmit={onAdd} />
		</Section>
	)
}
